import { Avatar, AvatarProps } from "@mui/material";
import React from "react";
import { User } from "../../../models/user";
import { getUserDescription, imageIsDefault, stringAvatar } from "../Utils";

export interface AvatarWithInitialsProps extends AvatarProps {
  user?: User | null; // accepte null ou undefined
}

const AvatarWithInitials: React.FC<AvatarWithInitialsProps> = ({
  user,
  sx,
  ...rest
}) => {
  if (!user) {
    return (
      <Avatar
        sx={{
          bgcolor: "#BDBDBD", // couleur grise par défaut
          ...sx,
        }}
        {...rest}
      >
        ?
      </Avatar>
    );
  }

  const nameDesc = getUserDescription(user);
  const { sx: avatarSx, children } = stringAvatar(nameDesc);

  return (
    <Avatar
      alt={nameDesc}
      src={!imageIsDefault(user.imageUrl) ? user.imageUrl : undefined}
      sx={{
        ...(!imageIsDefault(user.imageUrl) ? {} : avatarSx),
        ...sx,
      }}
      children={!imageIsDefault(user.imageUrl) ? undefined : children}
      {...rest}
    />
  );
};

export default AvatarWithInitials;
